import { Loader } from '@/design-system'
import { useI18n } from '@/i18n'
import { useNavigate } from '@solidjs/router'
import { type JSX, Show, createEffect, onMount } from 'solid-js'
import { authStore } from '../../stores/auth.store'
import { workspaceStore } from '../../stores/workspace.store'

interface GuestOnlyRouteProps {
  children: JSX.Element
  userType: 'candidate' | 'hiring_manager'
}

export function GuestOnlyRoute(props: GuestOnlyRouteProps) {
  const navigate = useNavigate()
  const { t } = useI18n()

  onMount(async () => {
    await authStore.checkAuth()
  })

  createEffect(() => {
    if (!authStore.state.isLoading && authStore.state.isAuthenticated) {
      const userType = authStore.state.userType

      if (userType === 'candidate') {
        navigate('/app/candidate/profile-hub', { replace: true })
      } else if (userType === 'hiring_manager') {
        const slug = workspaceStore.defaultWorkspaceSlug
        if (slug) {
          navigate(`/app/w/${slug}/dashboard`, { replace: true })
        } else {
          navigate('/app/w/create', { replace: true })
        }
      } else {
        navigate('/app/dashboard', { replace: true })
      }
    }
  })

  return (
    <Show
      when={!authStore.state.isLoading && !authStore.state.isAuthenticated}
      fallback={
        <div class="min-h-screen flex items-center justify-center bg-[var(--color-background)]">
          <div class="text-center">
            <Loader size={48} tone="current" class="inline-block" />
            <p class="mt-4 text-base text-[var(--color-text-muted)]">{t('common.loading')}</p>
          </div>
        </div>
      }
    >
      {props.children}
    </Show>
  )
}
